import React from 'react';
import { useModal } from '@/context/modalContext';
import { useModalBodyScroll } from '@/hooks/useModalBodyScroll';
import SelectCardModal from './SelectCardModal';
import { TermsModal } from './TermsModal';
import { modalTypes } from './constants';

const modals = {
  [modalTypes.SELECT_CARD_MODAL]: SelectCardModal,
  [modalTypes.TERMS_MODAL]: TermsModal,
};

const RootModal = () => {
  const { modalName } = useModal();
  const isOpen = !!modalName;
  useModalBodyScroll(isOpen);

  if (!isOpen) {
    return null;
  }

  const ModalComponent = modals[modalName];

  return <ModalComponent />;
};

export default RootModal;
